import { Link } from 'react-router-dom';
import type { Topic } from '@/mocks/topics';
import { formatHeat, statusStyle } from '@/utils/format';

interface TopicCardProps {
  topic: Topic;
}

function TopicCard({ topic }: TopicCardProps) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/topic/${topic.slug}`} className="block cursor-pointer">
        <div className="relative h-[188px] w-full overflow-hidden">
          <img
            src={topic.cover}
            alt={`${topic.title} - 网报吃瓜专题封面`}
            title={`${topic.title} - 网报吃瓜专题`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent" />
          <span className="absolute left-3 top-3 rounded-md bg-background-50/95 px-2.5 py-1 text-xs font-medium text-foreground-900">
            {topic.category}
          </span>
          <span
            className={`absolute right-3 top-3 rounded-md px-2.5 py-1 text-xs font-medium ${
              statusStyle[topic.status] || 'bg-accent-500 text-background-50'
            }`}
          >
            {topic.status}
          </span>
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
          <Link to={`/topic/${topic.slug}`} className="cursor-pointer hover:text-primary-700">
            {topic.title}
          </Link>
        </h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600 line-clamp-3">
          {topic.summary}
        </p>
        <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-background-200/80 pt-3 text-xs text-foreground-600">
          <span className="inline-flex items-center gap-1 text-accent-700">
            <i className="ri-fire-fill" />
            热度 {formatHeat(topic.heat)}
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-user-follow-line" />
            {topic.followers} 关注
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-refresh-line" />
            {topic.updateCount} 条更新
          </span>
        </div>
      </div>
    </article>
  );
}

export default TopicCard;